<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card" style="height: calc(100vh - 152px);width: 280px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :default-expanded-keys="openKeys" :expand-on-click-node="false">
                <span slot-scope="{ node }" class="custom-tree-node treeTitle" :title="node.label.split('###')[3]">
                    {{node.label.split('###')[0]}}
                    <span :class="'treeTitleNum'+node.label.split('###')[1]">{{node.label.split('###')[2]}}</span>
                </span>
            </el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <el-card class="box-card" style="width: calc(100% - 340px)">
            <div class="mainBody">
                <div class="dataBox" v-if="list_model ==0">
                    <el-alert title="请先选择左侧单元" type="warning" center :closable="false" show-icon style="height: 60px;"></el-alert>
                </div>
                <div style="width: 100%; color: #606266" v-if="list_model ==1">
                    <div style="width: 100%; display: flex;flex-direction: row;align-items: center;justify-content: center;">
                        <el-button type="primary"  @click="info" >查看统计结果</el-button>
                    </div>
                </div>
                <div class="titleBoxwhr" v-if="list_model ==2">
                    <h3>
                        单元号：{{unit.code}}
                    </h3>
                    <el-button style="margin-left: 50px" @click="back()">返回</el-button>
                    <el-button type="primary" style="margin-left: 10px" @click="expport()">导出</el-button>
                </div>

                <el-card class="box-card" style="height: 100%;margin-top: 25px" v-if="list_model ==2">
                    <el-radio-group v-model="echarts_show" size="small" @input="changeEcharts">
                        <el-radio-button label="1">注浆量</el-radio-button>
                        <el-radio-button label="2">注灰量/单位注灰量</el-radio-button>
                        <el-radio-button label="3">透水率</el-radio-button>
                        <el-radio-button label="4">灌浆长度</el-radio-button>
                    </el-radio-group>
                    <div class="echarts1" id="myChart1">
                        
                    </div>
                </el-card>
                
                <el-card class="box-card" style="height: 100%;margin-top: 25px" v-if="list_model ==2">
                    <el-table :data="tableData1" border stripe>
                        <el-table-column prop="sort" label="排序"></el-table-column>
                        <el-table-column prop="hole_order" label="孔序"></el-table-column>
                        <el-table-column prop="report_count" label="报告数量"></el-table-column>
                        <el-table-column prop="report_count_err" label="异常报告数量"></el-table-column>
                        <el-table-column prop="all_length" label="灌浆长度(m)"></el-table-column>
                        <el-table-column prop="segment_count" label="灌浆总段数"></el-table-column>
                        <el-table-column prop="grout_volume" label="注浆量(L)"></el-table-column>
                        <el-table-column prop="grout_volume1" label="差异注浆量(L)"></el-table-column>
                        <el-table-column prop="grout_volume_cha" label="差异值(L)"></el-table-column>
                        <el-table-column prop="ash_volume" label="注灰量(Kg)"></el-table-column>
                        <el-table-column prop="ash_volume1" label="差异注灰量(Kg)"></el-table-column>
                        <el-table-column prop="ash_volume_cha" label="差异值(Kg)"></el-table-column>
                        <el-table-column prop="ash_volume_unit" label="单位注灰量(kg/m)"></el-table-column>
                        <el-table-column prop="ash_volume_unit1" label="差异单位注灰量(kg/m)"></el-table-column>
                        <el-table-column prop="ash_volume_unit_cha" label="差异值(kg/m)"></el-table-column>
                        <el-table-column prop="segment_count_ys" label="压水总段数"></el-table-column>
                        <el-table-column prop="permeable_rate" label="透水率(Lu)"></el-table-column>
                        <el-table-column prop="permeable_rate1" label="差异透水率(Lu)"></el-table-column>
                        <el-table-column prop="permeable_rate_cha" label="差异值(Lu)"></el-table-column>
                    </el-table>
                </el-card>
            </div>
        </el-card>
    </div>
</template>

<script>
import listutil from "@/libs/listutil"
import { getProjectDivisionTreeData } from '@/api/org'
import { getUnitOrder, unitVerifyData, exportUnitVerifyData } from '@/api/statistic'

// 引入基本模板
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/bar')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/grid')
require('echarts/lib/component/legend')
require('echarts/lib/component/title')

export default {
    name: 'unitverifydiff',
    mixins: [listutil],
    data() {
        return {
            m_name: '单元工程统计',
            menu_id: 6520,
            enu_name: ['grout_type'],
            grade: 1,
            pid: 0,
            projectDivisionData: [],
            openKeys: [],
            list_model: 0,
            segment_no: '',
            tableData1: [],
            unit: {},
            echarts_show: 0,
            option: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {},
                grid: {
                    left: '4%',
                    right: '4%',
                    bottom: '0',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: [{
                    name:'',
                    type: 'value'
                },{
                    name:'',
                    type: 'value'
                }],
                series: [
                    {
                        name: '',
                        type: 'bar',
                        data: []
                    },
                    {
                        name: '',
                        type: 'bar',
                        data: []
                    }
                ]
            },
            option1: {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {},
                grid: {
                    left: '4%',
                    right: '4%',
                    bottom: '0',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: [{
                    name:'',
                    type: 'value'
                },{
                    name:'',
                    type: 'value'
                }],
                series: [
                    {
                        name: '',
                        type: 'bar',
                        yAxisIndex: 0,
                        data: []
                    },
                    {
                        name: '',
                        type: 'bar',
                        yAxisIndex: 0,
                        data: []
                    },
                    {
                        name: '',
                        type: 'bar',
                        yAxisIndex: 1,
                        data: []
                    },
                    {
                        name: '',
                        type: 'bar',
                        yAxisIndex: 1,
                        data: []
                    }
                ]
            },
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        getData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(17).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                    this.initOpenKeys()
                }
            })
        },
        initOpenKeys(){//哪些节点要展开
            this.openKeys = this.getAllNodeId(this.openKeys, this.projectDivisionData, 0)
        },
        getAllNodeId (expandedKeys, moduleDataList, level) {
            if(level>1){
                return expandedKeys
            }
            for (let i = 0; i < moduleDataList.length; i++) {
                expandedKeys.push(moduleDataList[i].value)
                if (moduleDataList[i].children) {
                    expandedKeys = this.getAllNodeId(expandedKeys, moduleDataList[i].children, level+1)
                }
            }
            return expandedKeys
        },
        clickPrjectDivision(data){
            this.pid = data.id
            getUnitOrder(this.pid, 2).then(res=>{
                if(res.code == 1){
                    this.list_model = 1
                }else{
                    this.list_model = 0
                    this.$msg(res.msg)
                }
            })
        },
        info() {
            this.list_model = 2
            const loading = this.$loading({
                lock: true,
                text: '正在执行...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            unitVerifyData(this.pid, 4).then(res=>{
                loading.close()
                if(res.code == 1){
                    this.tableData1 = res.data.list
                    this.unit = res.data.unit
                    this.line1 = res.data.line1
                    this.line2 = res.data.line2
                    this.line3 = res.data.line3
                    this.line4 = res.data.line4
                    this.line5 = res.data.line5
                    this.line11 = res.data.line11
                    this.line21 = res.data.line21
                    this.line31 = res.data.line31
                    this.line41 = res.data.line41
                    this.line51 = res.data.line51
                    this.option.xAxis.data = res.data.xAxis
                    this.option1.xAxis.data = res.data.xAxis
                    this.echarts_show = '1'
                    this.changeEcharts('1')
                }
            })
        },
        back(){
            this.list_model = 0
            this.tableData1 = []
            this.unit = {}
        },
        changeEcharts(e){
            if(e =='1'){
                this.option.yAxis.name = '注浆量(L)'
                this.option.series[0].name = '注浆量(L)'
                this.option.series[0].data = this.line1
                this.option.series[1].name = '差异注浆量(L)'
                this.option.series[1].data = this.line11
            }else if(e=='2'){
                this.option1.yAxis[0].name = '注灰量(Kg)'
                this.option1.yAxis[1].name = '单位注灰量(kg/m)'
                this.option1.series[0].name = '注灰量(Kg)'
                this.option1.series[0].data = this.line2
                this.option1.series[1].name = '差异注灰量(Kg)'
                this.option1.series[1].data = this.line21
                this.option1.series[2].name = '单位注灰量(kg/m)'
                this.option1.series[2].data = this.line3
                this.option1.series[3].name = '差异单位注灰量(kg/m)'
                this.option1.series[3].data = this.line31
            }else if(e=='3'){
                this.option.yAxis.name = '透水率(Lu)'
                this.option.series[0].name = '透水率(Lu)'
                this.option.series[0].data = this.line4
                this.option.series[1].name = '差异透水率(Lu)'
                this.option.series[1].data = this.line41
            }else if(e=='4'){
                this.option.yAxis.name = '灌浆长度(m)'
                this.option.series[0].name = '灌浆长度(m)'
                this.option.series[0].data = this.line5
                this.option.series[1].name = '差异灌浆长度(m)'
                this.option.series[1].data = this.line51
            }
            var myChart1 = echarts.init(document.getElementById("myChart1"));
            myChart1.clear()
            if(e =='2'){
                myChart1.setOption(this.option1);
            }else{
                myChart1.setOption(this.option);
            }
        },
        expport(){
            const loading = this.$loading({
                lock: true,
                text: '正在执行...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            exportUnitVerifyData(this.pid, 4).then(res=>{
                loading.close()
                if(res.code == 1){
                    window.open(res.data)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
    }
};
</script>
<style lang="less" scoped>
    .titleBoxwhr {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }
    .carBox .el-card:first-child /deep/ .el-card__body {
        padding: 20px 6px;
    }
    .el-table /deep/ .el-table__cell {
        padding: 10px 0;
    }
    .el-card /deep/ .el-card__header {
        padding: 10px 20px;
    }
    .echarts1{
        width: 100%;
        height: 250px;
        margin-top: 0;
    }
    .dataBox /deep/ .el-alert__title {
        font-size: 18px;
    }
</style>